module.exports = __webpack_public_path__ + "img/ImageBackground2.c949b326.png";